import axios from '../axios'
import { CMSNOTEROUTES } from 'src/router/Api'

export interface CmsNote {
	id: string
	content: string
	employee_id?: string
	target_type?: string | null
	target_id?: string | null
	created_at: string
	updated_at: string
}

export interface CmsNoteListParams {
	limit?: number
	offset?: number
	target_type?: string
	target_id?: string
	fields?: string
}

export const getCmsNotes = async (params: CmsNoteListParams) => {
	return await axios.get(CMSNOTEROUTES.name, {
		params,
	})
}

export const createCmsNote = async (payload: {
	content: string
	target_type?: string
	target_id?: string
}) => {
	return await axios.post(CMSNOTEROUTES.name, payload)
}

export const updateCmsNote = async (
	id: string,
	payload: {
		content: string
	},
) => {
	return await axios.put(CMSNOTEROUTES.item(id), payload)
}

export const deleteCmsNote = async (id: string) => {
	return await axios.delete(CMSNOTEROUTES.item(id))
}
